export default function IconEmptySync() {
    return (
        <svg
            width="121"
            height="100"
            viewBox="0 0 121 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M60.6033 99.4926C85.237 99.4926 105.207 95.7613 105.207 91.1584C105.207 86.5556 85.237 82.8242 60.6033 82.8242C35.9696 82.8242 16 86.5556 16 91.1584C16 95.7613 35.9696 99.4926 60.6033 99.4926Z"
                fill="#F5F5F7"
                fill-opacity="0.8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M93.7888 21.9026L89.2954 23.6461C89.18 23.6909 89.0542 23.7023 88.9326 23.6789C88.811 23.6555 88.6984 23.5982 88.6079 23.5137C88.5174 23.4292 88.4526 23.3208 88.4209 23.2011C88.3893 23.0813 88.392 22.9551 88.4289 22.8368L89.7033 18.7533C88 16.8164 87 14.4546 87 11.9059C87 5.33026 93.6566 0 101.868 0C110.078 0 116.736 5.33026 116.736 11.9059C116.736 18.4816 110.079 23.8118 101.868 23.8118C98.8888 23.8118 96.1151 23.1105 93.7888 21.9026Z"
                fill="#7B67FB"
            />
            <path
                d="M107.724 14.0555C108.759 14.0555 109.598 13.2264 109.598 12.2035C109.598 11.1807 108.759 10.3516 107.724 10.3516C106.689 10.3516 105.85 11.1807 105.85 12.2035C105.85 13.2264 106.689 14.0555 107.724 14.0555Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M97.8854 13.8238H94.1367L96.0433 10.583L97.8854 13.8238ZM100.228 10.583H103.508V13.8238H100.228V10.583Z"
                fill="white"
            />
            <path
                d="M60.4932 63.5319C47.913 63.5319 37.3707 59.8362 34.4924 54.8535C33.9863 55.7305 33.6909 56.6419 33.6909 57.5876V65.7416C33.6909 72.0409 45.6941 77.1517 60.4932 77.1517C75.3014 77.1517 87.3092 72.0409 87.3092 65.7416V57.5876C87.3092 56.6419 87.0093 55.7305 86.4986 54.8535C83.6203 59.8339 73.0872 63.5319 60.4932 63.5319Z"
                fill="#DCE0E6"
            />
            <path
                d="M60.4932 80.376C47.913 80.376 37.3707 76.6756 34.4924 71.7021C33.9863 72.5746 33.6909 73.4859 33.6909 74.4293V82.5902C33.6909 88.8918 45.6941 94.0004 60.4932 94.0004C75.3014 94.0004 87.3092 88.8941 87.3092 82.5902V74.4293C87.3092 73.4859 87.0093 72.5746 86.4986 71.7044C83.6203 76.6756 73.0872 80.376 60.4932 80.376Z"
                fill="#AB9EFF"
            />
            <path
                d="M86.5765 38.5449C86.0498 43.1612 74.5962 46.8547 60.4932 46.8547C46.3971 46.8547 34.9434 43.1612 34.4191 38.5472C33.9588 39.3853 33.6909 40.26 33.6909 41.1599V49.3139C33.6909 55.6155 45.6941 60.7241 60.4932 60.7241C75.3014 60.7241 87.3092 55.6178 87.3092 49.3139V41.1599C87.3092 40.26 87.0367 39.3853 86.5765 38.5449Z"
                fill="#AB9EFF"
            />
            <path
                d="M60.4933 44.2675C74.926 44.2675 86.6201 40.4046 86.6201 35.6326C86.6201 30.8652 74.926 27 60.4933 27C46.0698 27.0023 34.3711 30.8675 34.3711 35.6349C34.3711 40.4046 46.0698 44.2675 60.4933 44.2675Z"
                fill="#DCE0E6"
            />
        </svg>
    );
}
